import { useProjectStore } from "@/store/projectStore";

/**
 * Load a project from localStorage into the store.
 * Returns true if a saved project was found and restored.
 */
export function loadProjectFromStorage(projectId: string): boolean {
  const store = useProjectStore.getState();
  store.loadProject(projectId);
  return store.blocks.length > 0 || store.pages.length > 0;
}

/**
 * Get list of saved project IDs from localStorage.
 */
export function getSavedProjectIds(): string[] {
  const ids: string[] = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith("nuvra-project-")) {
      ids.push(key.replace("nuvra-project-", ""));
    }
  }
  return ids;
}

/**
 * Delete a project from localStorage.
 */
export function deleteProjectFromStorage(projectId: string) {
  localStorage.removeItem(`nuvra-project-${projectId}`);
  localStorage.removeItem(`nuvra-versions-${projectId}`);
}
